/**
 * MuiTable
 */
const MuiTable = {
  styleOverrides: {
    root: {
      maxHeight: '100%',
      maxWidth: '100%'
    }
  }
};

/**
 * MuiTableContainer
 */
export const MuiTableContainer = {
  styleOverrides: {
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      cursor: 'grab',
      '&:active': {
        cursor: 'grabbing !important'
      },
      '&::-webkit-scrollbar-track': {
        marginTop: '60px',
        marginBottom: '.5em',
        marginInline: '.5em'
      }
    }
  }
};
export default MuiTable;